<template>
  <div>
    <div class="container-fluid animate__animated animate__fadeIn animate__faster">
      <CondensedHeader
        :loading="loading"
        :mfg="mfg"
        :company="company"
        :cartAmount="cartAmount"
        :cart="cart"
        :cartVendorMatch="cartVendorMatch"
        :dropshipCart="dropshipCart"
        :condense="condense"
        :products="products"
        @back="back"
        @setMfg="setMfg"/>
      <ProductListing
        :query="query"
        :products="products"
        :mfg="mfg"
        :loading="loading"
        :condense="condense"/>
    </div>
    <FooterBars
      class="d-block d-sm-none animate__animated animate__slideInUp animate__faster"
      :mfgOptions="mfgOptions"
      :loading="loading"
      :mfg="mfg"
      :company="company"
      :cartAmount="cartAmount"
      :cart="cart"
      :cartVendorMatch="cartVendorMatch"
      :dropshipCart="dropshipCart"
      :condense="condense"/>
    <MobileFilterButton
      v-if="!loading"
      class="float-end mx-1 d-block d-sm-none"
      top="120"
      :loading="loading"/>
  </div>
</template>

<script setup>
  import ProductListing from './components/ProductListing.vue';
  import CondensedHeader from './components/CondensedHeader.vue';
  import FooterBars from './components/FooterBars.vue';
  import { ref, onBeforeMount, onMounted, computed } from 'vue';
  import { useStore } from 'vuex';
  import { processFilters } from '../../../../../repositories/filterActions';
  import MobileFilterButton from '../../../menus/mobile/filters/MobileFilterButton.vue';
  
  // Initialize
  const props = defineProps(['mfg', 'cart'])
  const store = useStore()

  // Data
  const selectedMfg = ref('')
  const condense = ref(true)
  
  // LifeCycle
  onBeforeMount(()=>{
    store.dispatch('getDropshipMfgProducts', props.mfg)
    store.dispatch('dropshipCartCheck', props.mfg)
  })

  onMounted(()=>{
    store.dispatch('dropshipClearQuery')
  })

  /* Methods */

  // Navigate back one step
  const back = ()=>{
    store.dispatch('stepBack')
  }

  const setMfg = (mfg)=>{
    selectedMfg.value = mfg
  }

  /* Computed */

  // Dropship Query
  const query = computed(()=>{
    return store.getters.dropshipQuery
  })

   // User session company
   const company = computed(()=>{
    return store.getters.sessionCompany
  })

  const loading = computed(()=>{
    return store.getters.dropshipLoading
  })
  
  // Product List
  const products = computed(()=>{
    return processFilters()
  })

  // Active Cart total
  const cartAmount = computed(()=>{
    if(dropshipCart.value && cartVendorMatch.value){
      return store.getters.cartTotal
    }
    return 0
  })

  const cartVendorMatch = computed(()=>{
    if(props.cart && props.mfg){
      return props.mfg.vendor_id == props.cart.details.dropship_vendor_id
    }
  })

  // Dropship cart Indicator
  const dropshipCart = computed(()=>{
    return store.getters.cart?.details?.dropship_cart 
  })

  // MFG Select Options
  const mfgOptions = computed(()=>{
    return _.uniq(_.map(products.value, p => p.mfg)).sort()
  })

</script>

<style scoped>
  select, option{
    cursor: pointer;
  }
  .filter-text{
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: -1.4em;
    right: 18.7em;
  }
</style>